
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class OthersGrid extends Serenity.EntityGrid<OthersRow, any> {
        protected getColumnsKey() { return 'OMS.Others'; }
        protected getDialogType() { return OthersDialog; }
        protected getIdProperty() { return OthersRow.idProperty; }
        protected getLocalTextPrefix() { return OthersRow.localTextPrefix; }
        protected getService() { return OthersService.baseUrl; }
        protected getInsertPermission() { return OthersRow.insertPermission; }
        protected getUpdatePermission() { return OthersRow.updatePermission; }
        protected getDeletePermission() { return OthersRow.deletePermission; }
        protected useViewMode() { return true; }


        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }

        protected addButtonClick() {


            this.editItem(<OthersRow>{
                ItemTypeId: 106,
                SubCategoryId: 305
            });
        }
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}